<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { reactive, ref, defineProps, defineEmits, watch } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG, PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    const props = defineProps({
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
    });
    const emit = defineEmits(['update:modelValue']);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loading = ref(false);
    const formData = reactive({
        echeances: [] as any[],
        mode_paiement: 'cash',
    });
    let paymentsOptions: any[] = [];

    watch(props, () => {
        if (props.modelValue) {
            Object.assign(formData, props.modelValue);
            if (formData.echeances.length > 0) {
                formData.echeances.forEach((echeance, index) => {
                    onEcheanceChanged(index);
                });
            }
            paymentsOptions = [
                { value: 'comptant', text: 'Paiement cash' },
                { value: 'echelonne', text: `Paiement par échéances (${props.startupFormDatas.market_echeances_time} mensualités)` },
                { value: 'mixed', text: `Paiement cash & par échéances (${props.startupFormDatas.market_echeances_time} mensualités)` },
            ];
        }
    }, { deep: true });

    watch(formData, () => {
        emit('update:modelValue', formData);
    }, { deep: true });

    function addEcheance() {
        formData.echeances.push({
            duration: null,
            taux_interet: 0,
            montant_mensualite: 0,
            nombre_mensualites: 0,
            montant_total: 0,
        });
    }

    async function onRemoveEcheance(echeanceIndex: number) {
        const confirmation = await confirmationModalRef.value?.open("Suppression Echéance", "Voulez-vous vraiment supprimer l'échéance sélectionnée ?");
        if (confirmation) {
            formData.echeances.splice(echeanceIndex, 1);
        }
    }

    function onEcheanceChanged(index: number) {
        const selectedEcheance = props.startupFormDatas.echeances.find((echeance: any) => echeance.value === formData.echeances[index].duration);
        if (selectedEcheance) {
            formData.echeances[index].montant_total = parseFloat(props.startupFormDatas.produit.montant) * (1 + (formData.echeances[index].taux_interet / 100));
            formData.echeances[index].montant_mensualite = formData.echeances[index].montant_total / selectedEcheance.coef;
            formData.echeances[index].nombre_mensualites = selectedEcheance.coef;
        }
    }
</script>

<template>
    <div>
        <h5 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
            Gestion des échéances
        </h5>
        <div class="form-field-floating full my-5">
            <select class="form-input-select" v-model="formData.mode_paiement" name="mode_paiement" id="mode_paiement">
                <option :value="option.value" v-for="(option, index) in paymentsOptions" :key="'option_' + index">
                    {{ option.text }}
                </option>
            </select>
            <label for="mode_paiement">Mode de paiement <b class="color-danger">*</b></label>
        </div>
        <!-- <table class="table">
            <thead>
                <tr>
                    <th>Echéance</th>
                    <th>Taux intérêt (%)</th>
                    <th>Montant mensualité</th>
                    <th>Nombre mensualité</th>
                    <th>Montant total</th>
                    <th width="10%"></th>
                </tr>
            </thead>
            <tbody>
                <template v-if="formData.echeances.length == 0">
                    <tr>
                        <td colspan="6">
                            <div class="text-center text-grey-700">Aucune échéance ajoutée</div>
                        </td>
                    </tr>
                </template>
                <tr v-for="(echeance, index) in formData.echeances" :key="'echeance_row_' + index">
                    <td>
                        <div class="form-field-floating full">
                            <select class="form-input-select" v-model="echeance.duration" name="echeance_duration[]" :id="'echeance_duration_' + index" @change="onEcheanceChanged(index)">
                                <option :value="null">Sélectionnez une durée</option>
                                <option :value="echeance.value" v-for="(echeance, index) in startupFormDatas.echeances" :key="'echeance_' + index">
                                    {{ echeance.text }}
                                </option>
                            </select>
                            <label :for="'echeance_duration_' + index">Durée échéance <b class="color-danger">*</b></label>
                        </div>
                    </td>
                    <td>
                        <div class="form-field-floating reactive active">
                            <money3 class="form-input" v-model="echeance.taux_interet" name="taux_interet" :id="'taux_interet_' + index" placeholder="" v-bind="PERCENTAGE_FORMAT_CONFIG"></money3>
                            <label :for="'taux_interet_' + index">Taux intérêt (%)</label>
                        </div>
                    </td>
                    <td>
                        <div class="form-field-floating reactive active">
                            <money3 class="form-input" v-model="echeance.montant_mensualite" name="montant_mensualite" :id="'montant_mensualite_' + index" placeholder="" v-bind="AMOUNT_FORMAT_CONFIG" :readonly="true"></money3>
                            <label :for="'montant_mensualite_' + index">Montant mensualité</label>
                        </div>
                    </td>
                    <td>
                        <div class="form-field-floating reactive active">
                            <money3 class="form-input" v-model="echeance.nombre_mensualites" name="nombre_mensualites" :id="'nombre_mensualites_' + index" placeholder="" v-bind="INTEGER_FORMAT_CONFIG" :readonly="true"></money3>
                            <label :for="'nombre_mensualites_' + index">Nombre mensualité</label>
                        </div>
                    </td>
                    <td>
                        <div class="form-field-floating reactive active">
                            <money3 class="form-input" v-model="echeance.montant_total" name="montant_total" :id="'montant_total_' + index" placeholder="" v-bind="AMOUNT_FORMAT_CONFIG" :readonly="true"></money3>
                            <label :for="'montant_total_' + index">Montant total</label>
                        </div>
                    </td>
                    <td>
                        <custom-button @click="onRemoveEcheance(index)" :classesList="'btn-ultra white2 tips'">
                            <img src="/icons/icon-delete.svg" class="btn-icon" alt="" />
                            <span>Supprimer</span>
                        </custom-button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="6" class="text-center">
                        <custom-button @click="addEcheance" type="button" :classesList="'btn lg w-100'" :loading="loading">
                            <span>Ajouter une échéance</span>
                        </custom-button>
                    </td>
                </tr>
            </tfoot>
        </table> -->
    </div>
</template>
